import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, Observable, of, Subscription } from 'rxjs';
import { AddSegmentsComponent } from '../add-segments/add-segments.component';
import { ISegment, ISegmentFilter, ISegmentFilterRequest } from '../../models/segment.model';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { DeleteSegments, DeleteSegmentsSuccess, FetchSegments } from '../../store/segments.actions';
import { IPageCount } from 'src/app/shared/models/page.model';
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'src/app/config/global.config';
import { ConfirmationPopUpComponent } from 'src/app/shared/confirmation-pop-up/confirmation-pop-up.component';
import { encodeFilterObject, parseFilterRequest, refillFilter } from 'src/app/shared/utils/helpers';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions } from '@ngrx/effects';
import { ofType } from '@ngrx/effects';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-list-segments',
  templateUrl: './list-segments.component.html',
  styleUrls: ['./list-segments.component.scss']
})
export class ListSegmentsComponent implements OnInit {
  segments$: Observable<ISegment[]> = this.store.select(state => state.segments.segments);
  pagination$: Observable<any> = this.store.select(state => state.segments.metadata);
  page: IPageCount = {
    size: DEFAULT_PAGE_SIZE,
    number: 1
  }
  filter: ISegmentFilterRequest | undefined = undefined;
  key: string | undefined = undefined;
  private subscriptions: Subscription[] = [];
  expandedIndex: number = -1;
  isAppLoading$ = this.store.select((state) => state.shared.isAppLoading);
  unparsedFilter:ISegmentFilter | null = null;
  module:string = 'segment';
  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>,
    private translateService: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private actions$: Actions
  ) { 
    this.activatedRoute.queryParams.subscribe(params => {
      const pageNumber = parseInt(params['page'] || '1');
      const pageCount = PAGE_SIZE_OPTIONS.includes(parseInt(params['count'])) ? parseInt(params['count']) : DEFAULT_PAGE_SIZE;
      this.key = params['keyword'] ?? '';
      if(params['filter'])
      {
        try {
          this.unparsedFilter = refillFilter(this.module, JSON.parse(decodeURIComponent(params['filter']))) as ISegmentFilter
          if(this.unparsedFilter)
            this.filter = parseFilterRequest(this.module, this.unparsedFilter);
        } catch (error) {
          this.filter == undefined
        }
      }
      this.page = { ...this.page, number: pageNumber, size: pageCount };
    });
  }

  ngOnInit(): void {
    const sub1 = this.store
      .select((state) => state.segments.segmentFilterState)
      .pipe(
        debounceTime(10),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
      )
      .subscribe((filter) => {
        this.unparsedFilter = filter.advanced;
        this.filter = parseFilterRequest(this.module, filter.advanced);
        this.key = filter.keyword;
        this.toPage(this.page);
      });

    this.subscriptions.push(sub1);
  }

  addSegments() {
    this.dialog.open(AddSegmentsComponent, {
      disableClose: true,
      position: { right: '0px', top: '0px' },
      width: '50vw',
      height: '100vh',
      minWidth: '650px'
    })
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  toPage(page: IPageCount) {
    this.page = { ...this.page, number: page.number, size: page.size };
    this.store.dispatch(FetchSegments({ page: this.page, filter: this.filter, key: this.key }))
    let filter:any = {}
    if(this.key && this.key != ''){
      filter.keyword = this.key;
    }
    filter.filter = encodeFilterObject(this.unparsedFilter);
    let queryParams = { page: this.page.number, count: this.page.size, ...filter };
    this.router.navigate([], {
      queryParams: queryParams
    });
  }
  toggleVariants(id: number) {
    this.expandedIndex = this.expandedIndex === id ? -1 : id;
  }

  opensSegments(segments: ISegment) {
    this.dialog.open(AddSegmentsComponent, {
      data: segments,
      disableClose: true,
      position: { right: '0px', top: '0px' },
      width: '50vw',
      height: '100vh',
      minWidth: '650px'
    })
  }
  delete(segment: number) {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        icon: '../../../assets/icones/cancel_alert.svg',
        confirm_text: this.translateService.instant('common.remove'),
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        const deleteSuccessSub = this.actions$.pipe(
          ofType(DeleteSegmentsSuccess),
          take(1)
        ).subscribe(() => {
          this.toPage(this.page);
          deleteSuccessSub.unsubscribe();
        });
        
        this.store.dispatch(DeleteSegments({ id: segment }));
      }
    });
  }
  public getStatusTranslation(status: string): string {
    return this.translateService.instant(`segment.segmentsStatus.${status}`) || status;
  }
  ngOnDestroy(): void{
  }
}
